import styled from 'styled-components'

export const DefaultPageHoc = styled.div``



// WEBPACK FOOTER //
// ./src/hocs/defaultPage.styles.js